<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">تعیین وضعیت مهارت‌ها</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 justify-content-center">
        <div class="col-md-3 mb-3" :class="!selectedOverview ? 'col-md-6' : ''">
          <label class="form-label fw-bold">مهارت</label>
          <VSelect
              v-model="selectedSkill"
              :options="skills"
              label="skill"
              placeholder="مهارت را انتخاب کنید"
              dir="rtl"
              @update:modelValue="toNull(['selectedOverview', 'selectedDetail'])">
            <template v-slot:no-options>
              مهارتی یافت نشد!
            </template>
          </VSelect>
        </div>

        <div class="col-md-3 mb-3" :class="!selectedOverview ? 'col-md-6' : ''" v-if="selectedSkill">
          <label class="form-label fw-bold">تشریح</label>
          <VSelect
              v-model="selectedOverview"
              :options="selectedSkill.overviews"
              label="overview"
              placeholder="تشریح را انتخاب کنید"
              dir="rtl"
              @update:modelValue="handleOverviewChange">
            <template v-slot:no-options>
              تشریحی یافت نشد!
            </template>
          </VSelect>
        </div>

        <div class="col-md-3 mb-3" v-if="selectedOverview &&
         selectedOverview.details &&
          selectedOverview.details.length > 0 &&
          selectedOverview.details[0].property">
          <label class="form-label fw-bold">ویژگی</label>
          <VSelect
              v-model="selectedDetail"
              :options="selectedOverview.details"
              label="property"
              placeholder="ویژگی را انتخاب کنید"
              dir="rtl">
            <template v-slot:no-options>
              ویژگی یافت نشد!
            </template>
          </VSelect>
        </div>

        <div class="col-md-3 mb-3" v-if="selectedDetail">
          <label class="form-label fw-bold">وضعیت</label>
          <VSelect
              v-model="selectedDetail.status"
              :options="statuses.map(status => ({ label: status ? 'دارد' : 'ندارد', value: status }))"
              :reduce="option => option.value"
              label="label"
              placeholder="وضعیت را انتخاب کنید"
              dir="rtl"
              @update:modelValue="setStatus">
            <template v-slot:no-options>
              وضعیتی یافت نشد!
            </template>
          </VSelect>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-6" v-if="selectedDetail">
          <label class="form-label fw-bold">توضیحات</label>
          <textarea
              class="form-control"
              rows="4"
              disabled
              v-model="selectedDetail.description"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import VSelect from "vue-select";

export default {
  components: {
    VSelect,
  },
  created() {
    this.$store.dispatch("crudActions/fetchInitialData", {
      endpoint: "/competencies/skills/index",
      afterMutation: "skills/setSkills",
    });
  },
  data() {
    return {
      selectedSkill: null,
      selectedOverview: null,
      selectedDetail: null,
      statuses: [true, false],
    };
  },
  computed: {
    skills: {
      get() {
        return this.$store.state.skills.skills;
      },
      set(value) {
        this.$store.commit("skills/setSkills", value);
      },
    },
  },
  methods: {
    toNull(data) {
      data.forEach((item) => (this[item] = null));
    },
    handleOverviewChange() {
      this.toNull(["selectedDetail"]);

      if (
          this.selectedOverview &&
          this.selectedOverview.details &&
          this.selectedOverview.details.length > 0
      ) {
        this.selectedDetail = this.selectedOverview.details[0];
      }
    },
    setStatus() {
      if (this.selectedDetail) {
        this.$store.dispatch("crudActions/create", {
          resourceData: {
            id: this.selectedDetail.id,
            status: this.selectedDetail.status,
          },
          endpoint: "/competencies/skills/set-status",
        });
        useToast().success("وضعیت ثبت شد.");
      }
    },
  },
};
</script>

<style scoped>
textarea {
  height: auto;
}
</style>
